<div class="dialog-wrapper">
  <h6 mat-dialog-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
      class="dialog-header">
    <span>{{ 'dashboard.tolerances' | translate }}</span>
    <button
      mat-icon-button
      mat-dialog-close
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h6>
  <div mat-dialog-content>
    <div class="flex-row gap-20">
      <div class="flex-50 table-wrapper">
        <colimo-tolerance-table
          [specialColoring]="data.toleranceData.specialColoring"
          [tableTitle]="titleBatchTable"
          [headerColumns]="headerColumns"
          [displayedColumns]="displayedColumns"
          [toleranceData]="batchTols"
        ></colimo-tolerance-table>
      </div>
      <div class="flex-50 table-wrapper">
        <colimo-tolerance-table
          [specialColoring]="data.toleranceData.specialColoring"
          [tableTitle]="titleLineTable"
          [headerColumns]="headerColumns"
          [displayedColumns]="displayedColumns"
          [toleranceData]="lineTols"
        ></colimo-tolerance-table>
      </div>
    </div>
  </div>
</div>
